/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/freeformsearch': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g _fill="none" _stroke="#272c33" class="nc-icon-wrapper" stroke-linecap="round" stroke-linejoin="round"><path pid="0" data-color="color-2" d="M11.5 11.5L8.328 8.328"/><circle pid="1" cx="5.5" cy="5.5" r="4"/></g>'
  }
})
